/**
 @Developper: BenAli Faker
 @Company: SMART-INFO
 @Post: CTO
 @Date:19/06/2021
 @Time:08:51
 **/
import "bootstrap-colorpicker/dist/js/bootstrap-colorpicker.min";
import "bootstrap-datepicker/dist/js/bootstrap-datepicker.min";
import "bootstrap-datepicker/js/locales/bootstrap-datepicker.ar";
import "bootstrap-datepicker/js/locales/bootstrap-datepicker.fr";
import "bootstrap-daterangepicker/daterangepicker";
import "bootstrap-markdown/js/bootstrap-markdown";
//import "bootstrap-multiselect/dist/js/bootstrap-multiselect"; Todo resolve import multiselect
import "bootstrap-select/dist/js/bootstrap-select";
//import "bootstrap-select/js/i18n/defaults-ar_AR";
//import "bootstrap-select/js/i18n/defaults-fr_FR";
import "bootstrap-timepicker/js/bootstrap-timepicker";
import "bootstrap-tagsinput/dist/bootstrap-tagsinput";
import "bootstrap-datepaginator/src/js/bootstrap-datepaginator";
import "bootstrap-touchspin/dist/jquery.bootstrap-touchspin";
import "./jquery-datetime-picker";//todo remplacer ce module si nécessaire par celui de crypto admin
import Select2 from "./select2";
window.Select2=Select2;
import "./jquery-validation";
import "ion-rangeslider/js/ion.rangeSlider";
//window.Inputmask= require ("inputmask/bundle");
import "inputmask/lib/jquery.inputmask";
//import "jquery-steps/build/jquery.steps";// jquery steps verifier si celui utilisé sinon on le supprime
import "jquery-wizard/dist/jquery-wizard";//jquery steps vérifier lequel est utilisé
import "formatter/index";//todo vérifier s'il est fonctionnelle l'import - Mask form elements
import Dropzone from "dropzone/dist/dropzone";"dropzone/dist/dropzone";
Dropzone.autoDiscover = false;//doit être mis a faux avant que le DOM sera ready
import TurndownService from "turndown";
window.TurndownService=TurndownService;//changer le code to-markdown a été changé vers turndown**/

